import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Room } from "../../../models/Room";
import { Fire } from "../../../services/FireClient";
import BotDocumentPart from "./BotDocumentPart";
import BotUtilityPart from "./BotUtilityPart";
import BotSoriPart from "./BotSoriPart";
import { useHistory } from "../../../hooks/useRouterCompat";
import { Button } from "../../../components/ui/button";
import { ArrowLeft } from "lucide-react";

export const RoomBotPage: React.FC = () => {
  const { roomId } = useParams<{ roomId: string; }>();
  const [room, setRoom] = useState<Room>();
  const history = useHistory();

  useEffect(() => {
    Fire.getRoom(roomId || "").then(r => {
      setRoom(r);
    });
  }, [roomId])

  return (
    <div className='flex flex-col h-screen bg-slate-50'>
      <header className="flex items-center px-4 h-14 border-b bg-white shrink-0 gap-2">
        <Button variant="ghost" size="icon" onClick={() => history.goBack()}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-lg font-semibold truncate">#{room?.name}</h1>
      </header>

      {room && (
        <div className="flex-1 overflow-y-auto p-4 space-y-4 max-w-3xl mx-auto w-full">
          <BotSoriPart room={room} />
          {room.bots?.some(b => b.type === 'ai-docubot') && <BotDocumentPart room={room} />}
          <BotUtilityPart room={room} />
        </div>
      )}
    </div>
  );
}

export default RoomBotPage;

/*
<IonSegment value={tab} onIonChange={e => setTab(e.detail.value as any)}>
  <IonSegmentButton value='general'><Trans>General bots</Trans></IonSegmentButton>
  <IonSegmentButton value='document'><Trans>Document bots</Trans></IonSegmentButton>
</IonSegment>
{tab == 'general' && <BotGeneralTab selectedBots={selectedBots} setSelectedBots={setSelectedBots} />}
{tab == 'document' && <BotDocumentTab selectedBots={selectedBots} setSelectedBots={setSelectedBots} />} 
*/